var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRecordSetDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1426_17665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5798 9.7425L14.5723 9.7575C14.6023 9.51 14.6323 9.255 14.6323 9C14.6323 8.745 14.6098 8.505 14.5798 8.2575L14.5873 8.2725L16.4173 6.8325L14.5948 3.6675L12.4423 4.5375L12.4498 4.545C12.0598 4.245 11.6323 3.99 11.1673 3.795H11.1748L10.8298 1.5H7.17734L6.84734 3.8025H6.85484C6.38984 3.9975 5.96234 4.2525 5.57234 4.5525L5.57984 4.545L3.41984 3.6675L1.58984 6.8325L3.41984 8.2725L3.42734 8.2575C3.39734 8.505 3.37484 8.745 3.37484 9C3.37484 9.255 3.39734 9.51 3.43484 9.7575L3.42734 9.7425L1.85234 10.98L1.60484 11.175L3.42734 14.325L5.58734 13.4625L5.57234 13.4325C5.96984 13.74 6.39734 13.995 6.86984 14.19H6.84734L7.18484 16.5H10.8223C10.8223 16.5 10.8448 16.365 10.8673 16.185L11.1523 14.1975H11.1448C11.6098 14.0025 12.0448 13.7475 12.4423 13.44L12.4273 13.47L14.5873 14.3325L16.4098 11.1825C16.4098 11.1825 16.3048 11.0925 16.1623 10.9875L14.5798 9.7425ZM8.99984 11.625C7.55234 11.625 6.37484 10.4475 6.37484 9C6.37484 7.5525 7.55234 6.375 8.99984 6.375C10.4473 6.375 11.6248 7.5525 11.6248 9C11.6248 10.4475 10.4473 11.625 8.99984 11.625Z",
    fill: "lightgray"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1426_17665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRecordSetDisable);
export default __webpack_public_path__ + "static/media/ic_record_set_disable.1c53e8b6b28c1ba1fc60fc29615104b5.svg";
export { ForwardRef as ReactComponent };